export const translations = {
  de: {
    appName: "SafeBuddy",
    tagline: "Dein digitaler Notfall-Begleiter",
    login: "Anmelden",
    register: "Registrieren",
    email: "E-Mail",
    password: "Passwort",
    firstName: "Vorname",
    lastName: "Nachname",
    googleSignIn: "Mit Google anmelden",
    noAccount: "Noch kein Konto? Registrieren",
    haveAccount: "Bereits ein Konto? Anmelden",
    or: "oder",
    logout: "Abmelden",
    // nav
    home: "Home",
    myProfile: "Mein Profil",
    safeBuddies: "Safe Buddies",
    settings: "Einstellungen",
    // dashboard
    hello: "Hallo",
    welcomeBack: "Schön, dass du wieder da bist!",
    activeTags: "Aktive Tags",
    lostTags: "Verlorene Tags",
    totalScans: "Scans",
    totalCalls: "Anrufe",
    totalMessages: "Nachrichten",
    quickActions: "Schnellzugriff",
    editProfile: "Profil bearbeiten",
    reportLost: "Tag als verloren melden",
    blockedTags: "Gesperrte Tags",
    blockBuddy: "Buddy sperren",
    unblockBuddy: "Buddy entsperren",
    confirmBlock: "Buddy wirklich sperren?",
    confirmBlockDesc: "Die öffentliche Finder-Seite zeigt dann: „Dieser SafeBuddy wurde gesperrt.“",
    blockConfirmBtn: "Ja, sperren",
    buddyBlocked: "Buddy gesperrt",
    buddyUnblocked: "Buddy entsperrt",
    tagBlocked: "Dieser SafeBuddy wurde gesperrt.",
    createSubtitle: "Tippen, ranhalten, fertig.",
    createHoldTag: "Halte deinen SafeBuddy Tag ans Gerät",
    createSuccess: "Dein SafeBuddy wurde erfolgreich erstellt",
    createFallbackMsg: "Link wurde kopiert. NFC Tools wird geöffnet – füge den Link dort ein und halte den Tag ans Gerät.",
    createAnother: "Noch einen erstellen",
    msgFormHint: "Optional: Schreibe dem Besitzer, wo du den Gegenstand gefunden hast und wie er dich erreichen kann.",
    foundLocation: "Fundort (optional)",
    finderPhone: "Deine Telefonnummer (optional)",
    pwaTitle: "Zum Startbildschirm hinzufügen",
    pwaHint: "Lege SafeBuddy wie eine echte App auf deinen Startbildschirm – mit eigenem Symbol.",
    homeAndroidTitle: "Android (Chrome)",
    homeAndroidStep1: "Öffne SafeBuddy in Chrome.",
    homeAndroidStep2: "Tippe oben rechts auf das Drei-Punkte-Menü.",
    homeAndroidStep3: "Wähle „Zum Startbildschirm hinzufügen“.",
    homeIosTitle: "iPhone (Safari)",
    homeIosStep1: "Öffne SafeBuddy in Safari.",
    homeIosStep2: "Tippe unten auf das Teilen-Symbol.",
    homeIosStep3: "Wähle „Zum Home-Bildschirm“.",
    writeTag: "Tag beschreiben",
    labelTag: "Beschriften",
    writeTagTitle: "NFC-Tag beschreiben",
    writeTagFallbackDesc: "Öffne die SafeBuddy App oder beschreibe den Tag direkt im Browser.",
    writeTagInstallTitle: "SafeBuddy App installieren",
    writeTagInstallDesc: "Mit der nativen App beschreibst du NFC-Tags am schnellsten – alle Daten sind bereits vorausgefüllt.",
    writeTagScan: "Scanne zum Installieren",
    writeTagBrowser: "Im Browser beschreiben",
    writeTagBrowserHint: "Funktioniert nur auf Android mit Chrome.",
    createdTitle: "SafeBuddy erstellt!",
    writeTagNow: "Tag jetzt beschreiben",
    createdLockedNote: "Der Tag wurde beschrieben und permanent gesperrt.",
    appLandingIntro: "Die SafeBuddy App beschreibt deine NFC-Tags im Handumdrehen – tippe einen Buddy an und halte deinen Tag ans Gerät. Alle Notfalldaten sind automatisch vorausgefüllt.",
    appLandingFeature1: "NFC-Tags mit einem Tippen beschreiben",
    appLandingFeature2: "Alle Buddy-Daten automatisch vorausgefüllt",
    appLandingFeature3: "Sicher & einfach – direkt aus deinem SafeBuddy-Konto",
    playStoreBtn: "Bei Google Play",
    appStoreBtn: "Im App Store",
    appComingSoon: "Bald verfügbar",
    backToApp: "Zurück zu SafeBuddy",
    pwaInstall: "Zum Startbildschirm hinzufügen",
    pwaShowSteps: "So installierst du die App",
    pwaShowIos: "Anleitung anzeigen (iPhone)",
    pwaAlreadyInstalled: "SafeBuddy ist bereits installiert. 🎉",
    pwaInstalledOk: "SafeBuddy wurde installiert!",
    pwaIos: "iPhone (Safari): Tippe unten auf „Teilen“ und dann auf „Zum Home-Bildschirm“.",
    pwaAndroid: "Android (Chrome): Öffne das Menü ⋮ oben rechts und wähle „App installieren“ bzw. „Zum Startbildschirm hinzufügen“.",
    versionHistory: "Versionshistorie",
    currentVersion: "Aktuell installiert",
    version: "Version",
    whatsNewTitle: "Was ist neu?",
    whatsNewClose: "Alles klar!",
    familyTitle: "Familie & Mitglieder",
    familyHint: "Lade Familienmitglieder ein. Verknüpfte Mitglieder können gemeinsame SafeBuddys ansehen und voll bearbeiten.",
    inviteCode: "Einladungscode",
    inviteEmailPlaceholder: "E-Mail des Mitglieds",
    joinCodePlaceholder: "Einladungscode eingeben",
    join: "Beitreten",
    leaveFamily: "Gruppe verlassen",
    you: "Du",
    inviteSent: "Einladung gesendet",
    joined: "Du bist der Familie beigetreten",
    left: "Gruppe verlassen",
    codeCopied: "Kopiert!",
    writeProtect: "Schreibschutz",
    writeProtectHint: "Sichere diesen Buddy mit einem persönlichen Code. Nur wer den Code kennt, kann den NFC-Tag über die App neu beschreiben.",
    writeCodePlaceholder: "Persönlicher Code",
    saveCode: "Code speichern",
    removeCode: "Schutz entfernen",
    codeSaved: "Schreibschutz aktualisiert",
    protected: "Geschützt",
    enterWriteCode: "Gib den persönlichen Code ein, um diesen Buddy neu zu beschreiben.",
    verify: "Bestätigen",
    wrongCode: "Falscher Code",
    roleEditor: "Bearbeiten",
    roleViewer: "Nur ansehen",
    owner: "Besitzer",
    removeMember: "Entfernen",
    roleUpdated: "Rolle aktualisiert",
    memberRemoved: "Mitglied entfernt",
    inviteRoleLabel: "Rolle für Einladung",
    viewerReadOnly: "Du hast nur Leserechte in dieser Familie. Bearbeiten, Sperren und Löschen sind deaktiviert.",
    secTitle: "Wie soll der Tag gesichert werden?",
    secAppOnly: "Nur App-Schutz",
    secAppOnlyDesc: "Jederzeit über die SafeBuddy App neu beschreibbar, geschützt durch einen persönlichen PIN.",
    secPermanent: "Permanenter Schreibschutz",
    secPermanentDesc: "Der Tag wird beim Beschreiben dauerhaft gesperrt (Tag Lock).",
    pinPrompt: "Vergib einen persönlichen PIN für diesen Buddy.",
    pinPlaceholder: "Persönlicher PIN",
    permWarnTitle: "Achtung: Diese Aktion kann nicht rückgängig gemacht werden.",
    permWarn: "Der NFC-Tag kann danach von niemandem mehr überschrieben werden, auch nicht von SafeBuddy.",
    permConfirm: "Ja, permanent sperren",
    lockSuccess: "Dein SafeBuddy wurde erstellt und der Tag ist jetzt permanent gesperrt.",
    lockFailed: "Tag-Sperre fehlgeschlagen oder vom Gerät nicht unterstützt (nur Android/Chrome).",
    lastModifiedBy: "Zuletzt geändert von",
    overview: "Gesamtübersicht",
    yourTags: "Deine Tags",
    profileStatus: "Profilstatus",
    profileActive: "Aktiv",
    profileLocked: "Gesperrt",
    // profile
    avatar: "Avatar",
    chooseAvatar: "Motiv wählen",
    uploadImage: "Eigenes Bild hochladen",
    emergencyContacts: "Kontakte",
    contactPhoneHint: "Die Nummer wird Findern nur angezeigt, wenn du die Option „Anrufen erlauben“ aktiviert hast.",
    profileNameHint: "Dieser Name wird Findern angezeigt, wenn dein Tag gescannt wird.",
    color_lavender: "Lavendel",
    color_mint: "Minze",
    color_peach: "Pfirsich",
    color_sky: "Himmel",
    color_pink: "Rosa",
    addContact: "Kontakt hinzufügen",
    name: "Name",
    relationship: "Beziehung",
    phone: "Telefon",
    notes: "Wichtige Hinweise",
    allergies: "Allergien",
    save: "Speichern",
    saved: "Gespeichert!",
    profileActiveToggle: "Profil aktiv (öffentlich sichtbar)",
    remove: "Entfernen",
    // tags
    tagsTitle: "SafeBuddy Tags",
    activateTag: "Tag aktivieren",
    activateHint: "Gib den Code oder die komplette SafeBuddy-URL ein",
    codePlaceholder: "z.B. a8F3kP9 oder safebuddy.at/t/a8F3kP9",
    activate: "Aktivieren",
    viewStats: "Statistik ansehen",
    statsLabel: "Statistik",
    sourceDefaultTitle: "Aus meinen Profildaten",
    sourceDefaultDesc: "Deine bereits hinterlegten persönlichen Daten werden verwendet.",
    sourceCustomTitle: "Neue Daten",
    sourceCustomDesc: "Gib individuelle Daten speziell für diesen SafeBuddy ein.",
    showMore: "Weitere anzeigen",
    showLess: "Weniger anzeigen",
    finderPreviewNote: "So sehen Finder deinen SafeBuddy",
    closeBtn: "Schließen",
    changeEmailTitle: "E-Mail-Adresse ändern",
    currentEmailLabel: "Aktuelle E-Mail-Adresse",
    newEmailLabel: "Neue E-Mail-Adresse",
    requestEmailChange: "Bestätigungslink senden",
    emailChangeSent: "Bestätigungslink an die neue Adresse gesendet.",
    confirmEmailTitle: "E-Mail bestätigen",
    emailConfirmed: "E-Mail-Adresse erfolgreich geändert.",
    emailConfirmError: "Bestätigung fehlgeschlagen oder Link abgelaufen.",
    adminBuddiesTitle: "SafeBuddy-Verwaltung",
    searchPlaceholder: "Suche nach Name oder Code…",
    searchCodePlaceholder: "Suche nach Code…",
    filterAll: "Alle",
    filterStatus: "Status",
    searchUserPlaceholder: "Suche nach Name oder E-Mail…",
    sortNewest: "Neueste",
    sortOldest: "Älteste",
    changePassword: "Passwort ändern",
    currentPassword: "Aktuelles Passwort",
    newPassword: "Neues Passwort",
    repeatPassword: "Neues Passwort wiederholen",
    savePassword: "Passwort speichern",
    pwMismatch: "Die neuen Passwörter stimmen nicht überein.",
    pwTooShort: "Das neue Passwort muss mindestens 8 Zeichen lang sein.",
    pwChanged: "Passwort erfolgreich geändert.",
    activationTitle: "Aktivierungscodes",
    activationRequiredLabel: "Aktivierungscode erforderlich",
    generateCodes: "Codes generieren",
    codesGenerated: "Codes erstellt",
    codeSent: "Code per E-Mail gesendet",
    codeUnused: "Unbenutzt",
    codeActive: "Teilw. eingelöst",
    codeRedeemed: "Eingelöst",
    codeDisabled: "Deaktiviert",
    usesPerCodeLabel: "Freischaltungen pro Code (0 = unbegrenzt)",
    redeemedWord: "eingelöst",
    unlimited: "unbegrenzt",
    printCodes: "Drucken",
    printInstruction: "Einlösen: SafeBuddy öffnen → „SafeBuddy erstellen“ → Code eingeben.",
    printPerCode: "Freischaltungen",
    noCodes: "Noch keine Codes generiert.",
    sendCode: "Senden",
    disableCode: "Deaktivieren",
    enableCode: "Aktivieren",
    sendCodeTitle: "Code per E-Mail senden",
    sendCodeDesc: "Sende diesen Aktivierungscode mit Anleitung an:",
    activationCodeLabel: "Aktivierungscode",
    activationCodeHint: "Gib den Code ein, den du erhalten hast (z. B. SBXXXX-XXXX).",
    activationCodeRequired: "Bitte gib einen Aktivierungscode ein.",
    activationsTitle: "Aktivierungen",
    activationsAvailableWord: "verfügbar",
    redeemCodeBtn: "Code einlösen",
    buyActivation: "Aktivierung kaufen",
    redeemTitle: "Aktivierungscode einlösen",
    redeem: "Einlösen",
    codeRedeemed: "Code eingelöst",
    noActivationsTitle: "Keine Aktivierungen verfügbar",
    noActivationsText: "Für die Erstellung eines neuen Buddys benötigst du eine Aktivierung.",
    haveCodeBtn: "Ich habe einen Code",
    activationsInfoHint: "Beim Erstellen wird 1 Aktivierung verbraucht.",
    footerPrivacy: "Datenschutz",
    footerTerms: "Nutzungsbedingungen",
    footerImprint: "Impressum",
    footerCookies: "Cookie-Richtlinie",
    footerWithdrawal: "Widerruf",
    noTags: "Noch keine Tags aktiviert.",
    status: "Status",
    // stats
    statsTitle: "Statistik",
    events: "Ereignisse",
    noEvents: "Noch keine Ereignisse aufgezeichnet.",
    eventScan: "Scan",
    eventCall: "Anruf",
    eventMessage: "Nachricht",
    back: "Zurück",
    // settings
    colorTheme: "Farbthema",
    language: "Sprache",
    german: "Deutsch",
    english: "Englisch",
    helpTitle: "Hilfe & NFC",
    nfcHowto: "Wie funktioniert NFC?",
    nfcExplain: "NFC (Near Field Communication) erlaubt es, Daten zu übertragen, indem du dein Smartphone nah an einen NFC-Tag hältst. SafeBuddy speichert eine Web-Adresse auf dem Tag – wird er gescannt, öffnet sich automatisch deine öffentliche Finder-Seite.",
    nfcWriteBtn: "NFC-Tag jetzt beschreiben",
    nfcWriteHint: "Nur auf unterstützten Geräten (Chrome auf Android).",
    nfcApps: "NFC-Schreib-Apps",
    nfcAppsIos: "iOS: NFC Tools im App Store",
    nfcAppsAndroid: "Android: NFC Tools bei Google Play",
    // finder
    finderTitle: "Notfall-Informationen",
    finderIntro: "Du hast einen SafeBuddy gefunden. Bitte hilf mit, die Person zu erreichen.",
    revealCall: "Nummer anzeigen & Anrufen",
    callNow: "Jetzt anrufen",
    leaveMessage: "Nachricht hinterlassen",
    yourName: "Dein Name (optional)",
    yourMessage: "Deine Nachricht",
    sendMessage: "Nachricht senden",
    messageSent: "Danke! Deine Nachricht wurde übermittelt.",
    tagLost: "Dieser Gegenstand wurde als VERLOREN gemeldet.",
    notAvailable: "Diese SafeBuddy-Seite ist derzeit nicht verfügbar.",
    importantInfo: "Wichtige Hinweise",
    poweredBy: "Bereitgestellt von SafeBuddy",
    confirmLost: "Wirklich als verloren melden?",
    confirmLostDesc: "Deine öffentliche Finder-Seite zeigt dann einen Verloren-Hinweis an.",
    cancel: "Abbrechen",
    confirm: "Ja, als verloren melden",
    selectTag: "Tag auswählen",
    createBuddy: "SafeBuddy erstellen",
    buddyName: "Name (optional)",
    buddyNamePlaceholder: "z.B. Schlüsselanhänger, Schulrucksack, Hundehalsband, Fahrrad, Kinderwagen, Reisekoffer",
    create: "Erstellen",
    creating: "Wird erstellt…",
    generatedUrl: "Deine SafeBuddy-URL",
    copyUrl: "URL kopieren",
    urlCopied: "URL kopiert!",
    rename: "Umbenennen",
    deleteBuddy: "Löschen",
    deleteConfirm: "SafeBuddy löschen?",
    deleteConfirmDesc: "Dieser SafeBuddy und alle zugehörigen Statistiken werden dauerhaft gelöscht.",
    manageBuddies: "Meine SafeBuddys",
    shareLocation: "Standort mitsenden",
    locationAttached: "Standort hinzugefügt ✓",
    locationError: "Standort konnte nicht ermittelt werden",
    viewLocation: "Standort ansehen",
    buddyCreated: "SafeBuddy erstellt!",
    unnamed: "Unbenannt",
    done: "Fertig",
    editBuddy: "Bearbeiten",
    buddyProfile: "SafeBuddy-Profil",
    dataSource: "Welche Daten anzeigen?",
    standardData: "Meine Profildaten",
    ownData: "Eigene Daten",
    displayName: "Angezeigter Name",
    contactOptions: "Kontaktmöglichkeiten",
    allowCalls: "Anrufen erlauben",
    allowMessages: "Nachrichten erlauben",
    editData: "Daten bearbeiten",
    buddyUpdated: "SafeBuddy aktualisiert",
    emailNotifications: "E-Mail-Benachrichtigungen",
    notifyScan: "E-Mail, wenn mein Tag gescannt wird",
    notifyMessage: "E-Mail bei neuer Nachricht",
    buddyAvatar: "Avatar / Profilbild",
    nfcGuide: "Bild-Anleitung: NFC-Tag beschreiben",
    downloadPdf: "Anleitung als PDF herunterladen",
    shareGuide: "Anleitung teilen",
    share: "Teilen",
    shareGuideText: "So beschreibst du deinen SafeBuddy NFC-Tag – hier ist die Anleitung:",
    linkCopied: "Link kopiert!",
    preview: "Vorschau",
    previewBanner: "Vorschaumodus – Scans werden nicht gezählt.",
    feedbackTitle: "Feedback",
    feedbackHint: "Erzähl uns, was dir gefällt oder was wir verbessern können.",
    feedbackPlaceholder: "Deine Nachricht an uns …",
    anonymous: "Anonym senden",
    sendFeedback: "Feedback senden",
    feedbackSent: "Danke für dein Feedback! 💜",
    legalTitle: "Rechtliches & Datenschutz",
    imprint: "Impressum",
    imprintText: "Inhaber der Web-App:\nWalch Mathias\nMW3D\nNeufeldstraße 13\nA-6890 Lustenau\nKontakt: office@mw3d.at",
    privacy: "Datenschutz",
    privacyText: "Verantwortlicher: Walch Mathias (MW3D), Neufeldstraße 13, A-6890 Lustenau, office@mw3d.at.\n\nWelche Daten? Konto (E-Mail), Profil (Name, Avatar, Notfallkontakte, Hinweise, Allergien), SafeBuddy-Tags sowie Statistik-Ereignisse (Scans, Anrufe, Nachrichten mit Zeitstempel). Freigegebene Notfalldaten sind über die öffentliche Finder-URL abrufbar – du entscheidest selbst, welche Daten sichtbar sind und ob ein Tag aktiv ist.\n\nZweck & Rechtsgrundlage: Bereitstellung des Dienstes (Vertragserfüllung) sowie E-Mail-Benachrichtigungen, sofern von dir aktiviert.\n\nSpeicherdauer: Daten werden gespeichert, bis du sie löschst bzw. dein Konto oder Tag entfernst.\n\nDeine Rechte: Auskunft, Berichtigung, Löschung und Widerspruch – Anfragen an office@mw3d.at.\n\nDrittanbieter: Für E-Mail-Versand und Bildspeicherung werden Auftragsverarbeiter eingesetzt; Daten werden ausschließlich zur Erbringung des Dienstes verarbeitet.",
    policies: "Sonstige Richtlinien",
    policiesText: "Nutzungsbedingungen (Kurzfassung): SafeBuddy verbindet Finder verlorener Gegenstände über NFC/QR mit dir. Missbrauch (z. B. Hinterlegen fremder/falscher Daten oder belästigende Nachrichten) ist untersagt.\n\nHaftung: Es besteht keine Gewähr, dass ein Finder Kontakt aufnimmt. Setze in Notfällen immer offizielle Notrufnummern ab.\n\nStandort: Finder können optional und freiwillig ihren Standort mitsenden.\n\nKontakt: office@mw3d.at",
    eventsScansTitle: "Alle Scans",
    eventsCallsTitle: "Alle Anrufe",
    eventsMessagesTitle: "Alle Nachrichten",
    noEventsYet: "Noch keine Einträge.",
    skip: "Überspringen",
    next: "Weiter",
    getStarted: "Los geht's!",
    inboxTitle: "Nachrichten-Posteingang",
    noMessagesInbox: "Noch keine Nachrichten.",
    restartOnboarding: "Einführung erneut ansehen",
    featuresTitle: "Funktionen im Überblick",
    featPreview: "Vorschau: Auf „Safe Buddies“ beim Tag auf das Auge-Symbol tippen – so siehst du deine öffentliche Finder-Seite, ohne dass Scans gezählt werden.",
    featProfile: "Mein Profil: Notfalldaten einmalig eintragen – sie gelten automatisch für alle Tags.",
    featStats: "Statistik: Oben auf Home die Felder Scans/Anrufe/Nachrichten antippen für alle Details.",
    featLost: "Verloren melden: Tag als verloren markieren – Finder sehen dann einen deutlichen Hinweis.",
    onbTitle1: "Willkommen bei SafeBuddy! 🐾",
    onbText1: "SafeBuddy verbindet verlorene Gegenstände über NFC-Tags mit deinen Notfallkontakten – ganz ohne App-Download.",
    onbTitle2: "Mein Profil zuerst ausfüllen ⭐",
    onbText2: "Trage deine persönlichen Notfalldaten EINMALIG unter „Mein Profil“ ein (Name, Kontakte, Hinweise, Allergien). Diese Daten stehen dann automatisch für ALLE deine SafeBuddy Tags zur Verfügung.",
    onbTitle3: "Tags erstellen & teilen 🎉",
    onbText3: "Erstelle SafeBuddy Tags, beschreibe deinen NFC-Tag mit der URL und sieh in der Statistik, wann jemand deinen Tag gescannt oder dich kontaktiert hat.",
    showHelpQuestion: "NFC-Anleitung anzeigen?",
    showHelpHint: "Zeigt dir nach dem Erstellen, wie du den NFC-Tag beschreibst.",
    callHint: "Wenn aktiviert, wird deine Telefonnummer angezeigt und kann angerufen werden.",
    buddyActive: "SafeBuddy aktiv",
    deactivatedNotice: "Dieser SafeBuddy wurde deaktiviert.",
    editMyProfile: "Meine Profildaten ändern",
    openGuide: "Bebilderte Anleitung öffnen",
    guideTitle: "Bebilderte Anleitung",
    guideIntro: "In 5 einfachen Schritten von der Anmeldung bis zum fertigen SafeBuddy-Tag.",
    guideStepLabel: "Schritt",
    guideBackToSettings: "Zurück zu den Einstellungen",
    guideS1Title: "Profil ausfüllen",
    guideS1Text: "Öffne „Mein Profil“ und trage deine Notfalldaten EINMALIG ein: Name, Notfallkontakte, wichtige Hinweise und Allergien. Diese Daten gelten dann automatisch für alle deine SafeBuddys.",
    guideS1Marker: "Tippe auf „Kontakt hinzufügen“ und speichere.",
    guideS2Title: "SafeBuddy erstellen",
    guideS2Text: "Wechsle zu „Safe Buddies“ und tippe unten rechts auf das große Plus-Symbol. Gib einen Namen ein (z. B. Schulrucksack) und tippe auf „Erstellen“.",
    guideS2Marker: "Das Plus öffnet den Erstellen-Dialog.",
    guideS3Title: "Deine URL kopieren",
    guideS3Text: "Nach dem Erstellen bekommst du eine persönliche SafeBuddy-URL. Tippe auf „URL kopieren“ – die Adresse liegt jetzt in der Zwischenablage.",
    guideS3Marker: "Diese URL kommt gleich auf den NFC-Tag.",
    guideS4Title: "NFC-Tag beschreiben",
    guideS4Text: "Nutze in SafeBuddy den Button „NFC-Tag jetzt beschreiben“ (Android/Chrome) ODER eine NFC-App wie „NFC Tools“. Halte dein Handy an den Tag und speichere die kopierte URL als Web-Adresse (URL/Link).",
    guideS4Marker: "Handy an den Tag halten – kurz warten – fertig.",
    guideS5Title: "Fertig – so sieht es der Finder",
    guideS5Text: "Scannt jemand den Tag mit dem Handy, öffnet sich automatisch deine Finder-Seite mit deinen Notfallinfos. Du wirst sofort per E-Mail benachrichtigt.",
    guideS5Marker: "Anrufen oder Nachricht hinterlassen – ganz ohne App.",
    nfcWriteTitle: "NFC-Tag beschreiben",
    nfcWriteAndroidHint: "Funktioniert nur auf Android mit Chrome.",
    nfcWriteSelectTag: "Wähle einen deiner aktiven SafeBuddy Tags:",
    nfcWriteNoActiveTags: "Du hast noch keine aktiven Tags. Erstelle oder aktiviere zuerst einen SafeBuddy.",
    nfcWriteHoldTag: "Halte jetzt dein Handy an den NFC-Tag …",
    nfcWriteSuccess: "NFC-Tag erfolgreich beschrieben!",
    nfcWriteFailed: "NFC-Schreiben fehlgeschlagen. Bitte erneut versuchen.",
    nfcWriteAgain: "Weiteren Tag beschreiben",
    nfcWriteUnsupportedText: "Dein Gerät oder Browser unterstützt das direkte NFC-Schreiben nicht (z. B. iPhone oder Desktop). Nutze stattdessen eine kostenlose NFC-App: Kopiere die URL deines Tags und schreibe sie damit auf den Tag.",
    nfcWriteCopyLabel: "URL zum Einfügen in die NFC-App:",
    messageEmailHint: "Tipp: In den Einstellungen kannst du eine E-Mail-Benachrichtigung aktivieren, sobald dir jemand eine Nachricht hinterlässt.",
    onbViewGuide: "Bebilderte Anleitung ansehen",
    admin: "Admin",
    adminTitle: "Admin-Bereich",
    adminSubtitle: "Übersicht & Statistiken",
    adminTotalUsers: "Registrierte Nutzer",
    adminTotalTags: "Erstellte Tags",
    adminActiveTags: "Aktive Tags",
    adminBlockedTags: "Gesperrte Tags",
    adminLostTags: "Verlorene Tags",
    adminRecentUsers: "Neueste Registrierungen",
    adminNoUsers: "Noch keine Nutzer.",
    // shop
    shop: "Shop",
    shopTitle: "SafeBuddy Shop",
    shopSubtitle: "Aktivierungscodes bequem kaufen",
    activityTitle: "Aktivität",
    activitySubtitle: "Alle Scans, Anrufe & Nachrichten",
    eventsMarkAllRead: "Alle als gelesen",
    eventsDeleteAll: "Alle löschen",
    markRead: "Als gelesen",
    markUnread: "Als ungelesen",
    eventsDeleteConfirmTitle: "Einträge löschen?",
    eventsDeleteConfirmDesc: "Möchtest du die ausgewählten Einträge wirklich löschen? Du kannst es 5 Sekunden lang rückgängig machen.",
    eventsSearchPlaceholder: "Suche nach Datum, Buddy oder Inhalt",
    sortDateDesc: "Neueste zuerst",
    sortDateAsc: "Älteste zuerst",
    sortByBuddy: "Nach Buddy",
    sortByType: "Nach Typ",
    selectMultiple: "Mehrere auswählen",
    deleteSelected: "Löschen",
    eventsDeleted: "Gelöscht",
    deleteFailed: "Löschen fehlgeschlagen",
    undo: "Rückgängig",
    edit: "Bearbeiten",
    delete: "Löschen",
    ticketUpdated: "Ticket aktualisiert",
    ticketDeleted: "Ticket gelöscht",
    ticketBeingHandled: "Ticket wird bereits bearbeitet",
    outOfStock: "Nicht verfügbar",
    deleteTicketTitle: "Ticket löschen?",
    deleteTicketDesc: "Möchtest du dieses Ticket wirklich löschen? Du kannst es 5 Sekunden lang rückgängig machen.",
    ordersTitle: "Bestell-Verlauf",
    ordersSubtitle: "Deine Bestellungen & gekauften Codes",
    ordersEmpty: "Du hast noch keine Bestellungen aufgegeben.",
    ordersCardTitle: "Bestell-Verlauf",
    ordersCardSubtitle: "Bestellungen ansehen & Codes abrufen",
    orderStatusPaid: "Bezahlt",
    orderStatusPending: "Ausstehend",
    orderStatusFailed: "Fehlgeschlagen",
    orderDiscount: "Rabatt",
    orderShipping: "Versand",
    orderFree: "Kostenlos",
    orderTotal: "Gesamt",
    orderCodes: "Deine Aktivierungscodes",
    orderCodesHint: "Löse die Codes unter Einstellungen → „Aktivierungscode einlösen“ ein.",
    orderCopy: "Kopieren",
    orderCodeCopied: "Code kopiert",
    shopAdminTitle: "Shop-Verwaltung",
    shopEnabledLabel: "Shop für alle Nutzer freischalten",
    shopEnabledHint: "Solange dies aus ist, sehen nur Admins den Shop.",
    shopPreview: "Shop-Vorschau öffnen",
    paypalConfigured: "PayPal ist verbunden",
    paypalNotConfigured: "PayPal-Zugangsdaten fehlen noch – Käufe sind erst nach Eintragen der Keys möglich.",
    shopProductsTitle: "Produkte",
    shopOrdersTitle: "Bestellungen",
    newProduct: "Neues Produkt",
    editProductTitle: "Produkt bearbeiten",
    productName: "Name",
    productDesc: "Beschreibung",
    productPrice: "Preis (€)",
    productCodesCount: "Enthaltene Aktivierungscodes",
    productVisible: "Sichtbar im Shop",
    productImage: "Produktbild",
    uploadImage: "Bild hochladen",
    saveProduct: "Produkt speichern",
    deleteProductConfirm: "Dieses Produkt wirklich löschen?",
    noProducts: "Noch keine Produkte angelegt.",
    noOrders: "Noch keine Bestellungen.",
    hidden: "Versteckt",
    visibleBadge: "Sichtbar",
    codesIncluded: "Codes",
    buyNow: "Kaufen",
    shopClosed: "Der Shop ist derzeit nicht verfügbar.",
    shopEmpty: "Aktuell sind keine Produkte verfügbar.",
    checkoutTitle: "Kauf abschließen",
    paymentComingSoon: "Die Zahlung wird bald verfügbar sein. Bitte schau später noch einmal vorbei.",
    taxNote: "Gemäß § 6 Abs. 1 Z 27 UStG wird keine Umsatzsteuer berechnet. Alle Preise sind Bruttopreise.",
    mustAcceptTerms: "Bitte akzeptiere die Nutzungsbedingungen und die Datenschutzerklärung.",
    discountCodeLabel: "Rabattcode",
    applyLabel: "Anwenden",
    discountApplied: "Rabatt angewendet",
    discountLabel: "Rabatt",
    fromPhonebook: "Aus Telefonbuch wählen",
    simpleModeLabel: "Einfach-Modus",
    simpleModeHint: "Reduziert die App auf das Wesentliche: nur SafeBuddy erstellen.",
    createNewBuddy: "Neuen SafeBuddy erstellen",
    toFullView: "Zur vollständigen Ansicht",
    simpleOn: "An",
    simpleOff: "Aus",
    guestTryFree: "Testen ohne Registrierung",
    guestModeTitle: "Testmodus",
    guestModeDesc: "Deine Daten werden automatisch gelöscht. Jetzt registrieren, um alles zu behalten.",
    guestDaysPrefix: "noch",
    guestRegisterNow: "Jetzt registrieren",
    guestEmailLabel: "E-Mail für Erinnerung (optional)",
    guestEmailSave: "Speichern",
    guestEmailSaved: "E-Mail gespeichert",
    guestConvertTitle: "Konto erstellen & Daten behalten",
    guestConvertDesc: "Deine Testdaten (SafeBuddys, Profil, Historie) werden automatisch übernommen.",
    guestConvertSuccess: "Willkommen! Deine Daten wurden übernommen.",
    convertCreate: "Konto erstellen",
    designStyle: "Design",
    groups: "Gruppen",
    designClassic: "Klassisch",
    designModern: "Modern",
    hourWord: "Stunde",
    hoursWord: "Stunden",
    color_petrol: "Petrol",
    color_navy: "Dunkelblau",
    color_graphit: "Graphit",
    color_forest: "Dunkelgrün",
    color_bordeaux: "Bordeaux",
    dayWord: "Tag",
    daysWord: "Tage",
    guestNoEmail: "Keine E-Mail",
    guestStatusActive: "Aktiv",
    guestStatusExpired: "Abgelaufen",
    guestStatusConverted: "Konvertiert",
    adminGuestsTitle: "Gastzugänge",
    adminGuestsSubtitle: "Temporäre Testkonten mit Ablaufdatum",
    adminGuestsEmpty: "Noch keine Gastzugänge",
    adminGuestsBuddies: "SafeBuddys",
    adminGuestExpires: "Läuft ab",
    adminGuestConverted: "Konvertiert",
    pinPrefilledHint: "PIN wurde automatisch übernommen – du kannst ihn bestätigen oder ändern.",
    purchaseSuccessTitle: "Kauf erfolgreich! 🎉",
    purchaseSuccessDesc: "Deine Aktivierungscodes wurden per E-Mail gesendet:",
    orderPending: "Offen",
    orderPaid: "Bezahlt",
    orderFailed: "Fehlgeschlagen",
    buyer: "Käufer",
    close: "Schließen",
    edit: "Bearbeiten",
    delete: "Löschen",
    addToCartLabel: "In den Warenkorb",
    cartTitle: "Warenkorb",
    emptyCart: "Dein Warenkorb ist leer.",
    continueShopping: "Weiter einkaufen",
    chooseColor: "Farbe wählen",
    chooseMotif: "Motiv wählen",
    quantityLabel: "Menge",
    unitPriceLabel: "Einzelpreis",
    lineTotalLabel: "Gesamt",
    addLabel: "Hinzufügen",
    subtotalLabel: "Zwischensumme",
    shippingLabel: "Versand",
    shippingCostLabel: "Versandkosten",
    totalLabel: "Gesamtbetrag",
    freeLabel: "Kostenlos",
    deliveryTimeLabel: "Lieferzeit",
    chooseShipping: "Versandoption wählen",
    customerNameLabel: "Name",
    customerEmailLabel: "E-Mail",
    deliveryAddressLabel: "Lieferadresse",
    checkoutSummary: "Bestellübersicht",
    fillRequired: "Bitte alle Pflichtfelder ausfüllen.",
    chooseShippingFirst: "Bitte eine Versandoption wählen.",
    itemColorLabel: "Farbe",
    itemMotifLabel: "Motiv",
    removeLabel: "Entfernen",
    proceedCheckout: "Weiter zur Kasse",
    priceFrom: "ab",
    cartAdded: "Zum Warenkorb hinzugefügt",
    colorsLabel: "Farbvarianten",
    motifsLabel: "Motivvarianten",
    addColor: "Farbe hinzufügen",
    addMotif: "Motiv hinzufügen",
    variantName: "Name",
    variantDesc: "Beschreibung",
    variantHex: "Farbe (Hex)",
    variantSurcharge: "Aufpreis (€)",
    variantImage: "Bild",
    minQtyLabel: "Min. Menge",
    maxQtyLabel: "Max. Menge",
    shippingAdminTitle: "Versand",
    newShipping: "Neue Versandoption",
    editShippingTitle: "Versandoption bearbeiten",
    shippingName: "Name",
    shippingDesc: "Beschreibung",
    shippingPrice: "Preis (€)",
    shippingDeliveryTime: "Lieferzeit (z.B. 1-3 Werktage)",
    shippingFreeAbove: "Kostenloser Versand ab (€, optional)",
    shippingActive: "Aktiv",
    noShipping: "Noch keine Versandoptionen.",
    saveShipping: "Speichern",
    deleteShippingConfirm: "Diese Versandoption wirklich löschen?",
    streetLabel: "Straße",
    houseNumberLabel: "Hausnummer",
    postalCodeLabel: "Postleitzahl",
    cityLabel: "Ort",
    countryLabel: "Land",
    selectCountry: "Land wählen",
    shippingBasePrice: "Standardpreis (Fallback)",
    countryRates: "Länder-Versandkosten",
    countryRatesHint: "Leer lassen = Standardpreis wird verwendet.",
    forgotPassword: "Passwort vergessen?",
    resetEmailPrompt: "Gib deine E-Mail-Adresse ein und wir senden dir einen Link zum Zurücksetzen.",
    sendResetLink: "Reset-Link senden",
    backToLogin: "Zurück zur Anmeldung",
    resetSent: "Falls ein Konto existiert, haben wir dir einen Reset-Link per E-Mail geschickt.",
    resetTitle: "Neues Passwort vergeben",
    newPassword: "Neues Passwort",
    confirmPassword: "Passwort bestätigen",
    resetSubmit: "Passwort speichern",
    resetSuccess: "Passwort geändert! Du kannst dich jetzt anmelden.",
    resetInvalid: "Der Link ist ungültig oder abgelaufen.",
    passwordsMismatch: "Passwörter stimmen nicht überein.",
    passwordTooShort: "Das Passwort muss mindestens 6 Zeichen lang sein.",
    pwStrength: "Passwort-Stärke",
    pwWeak: "Schwach",
    pwMedium: "Mittel",
    pwGood: "Gut",
    pwStrong: "Stark",
  },
  en: {
    appName: "SafeBuddy",
    tagline: "Your digital emergency companion",
    login: "Sign in",
    register: "Sign up",
    email: "Email",
    password: "Password",
    firstName: "First name",
    lastName: "Last name",
    googleSignIn: "Sign in with Google",
    noAccount: "No account yet? Sign up",
    haveAccount: "Already have an account? Sign in",
    or: "or",
    logout: "Sign out",
    home: "Home",
    myProfile: "My Profile",
    safeBuddies: "Safe Buddies",
    settings: "Settings",
    hello: "Hi",
    welcomeBack: "Great to see you again!",
    activeTags: "Active tags",
    lostTags: "Lost tags",
    totalScans: "Scans",
    totalCalls: "Calls",
    totalMessages: "Messages",
    quickActions: "Quick actions",
    editProfile: "Edit profile",
    reportLost: "Report tag as lost",
    blockedTags: "Blocked tags",
    blockBuddy: "Block buddy",
    unblockBuddy: "Unblock buddy",
    confirmBlock: "Really block this buddy?",
    confirmBlockDesc: "The public finder page will then show: \"This SafeBuddy has been blocked.\"",
    blockConfirmBtn: "Yes, block",
    buddyBlocked: "Buddy blocked",
    buddyUnblocked: "Buddy unblocked",
    tagBlocked: "This SafeBuddy has been blocked.",
    createSubtitle: "Tap, hold, done.",
    createHoldTag: "Hold your SafeBuddy tag to the device",
    createSuccess: "Your SafeBuddy was created successfully",
    createFallbackMsg: "Link copied. NFC Tools will open – paste the link there and hold the tag to the device.",
    createAnother: "Create another",
    msgFormHint: "Optional: tell the owner where you found the item and how they can reach you.",
    foundLocation: "Found at (optional)",
    finderPhone: "Your phone number (optional)",
    pwaTitle: "Add to home screen",
    pwaHint: "Keep SafeBuddy on your home screen like a real app – with its own icon.",
    homeAndroidTitle: "Android (Chrome)",
    homeAndroidStep1: "Open SafeBuddy in Chrome.",
    homeAndroidStep2: "Tap the three-dot menu at the top right.",
    homeAndroidStep3: "Choose 'Add to Home screen'.",
    homeIosTitle: "iPhone (Safari)",
    homeIosStep1: "Open SafeBuddy in Safari.",
    homeIosStep2: "Tap the Share icon at the bottom.",
    homeIosStep3: "Choose 'Add to Home Screen'.",
    writeTag: "Write tag",
    labelTag: "Label",
    writeTagTitle: "Write NFC tag",
    writeTagFallbackDesc: "Open the SafeBuddy app or write the tag directly in your browser.",
    writeTagInstallTitle: "Install the SafeBuddy app",
    writeTagInstallDesc: "The native app is the fastest way to write NFC tags – all data is pre-filled for you.",
    writeTagScan: "Scan to install",
    writeTagBrowser: "Write in browser",
    writeTagBrowserHint: "Only works on Android with Chrome.",
    createdTitle: "SafeBuddy created!",
    writeTagNow: "Write tag now",
    createdLockedNote: "The tag has been written and permanently locked.",
    appLandingIntro: "The SafeBuddy app writes your NFC tags in seconds – tap a buddy and hold your tag to the device. All emergency data is filled in automatically.",
    appLandingFeature1: "Write NFC tags with a single tap",
    appLandingFeature2: "All buddy data pre-filled automatically",
    appLandingFeature3: "Secure & simple – straight from your SafeBuddy account",
    playStoreBtn: "Get it on Google Play",
    appStoreBtn: "Download on the App Store",
    appComingSoon: "Coming soon",
    backToApp: "Back to SafeBuddy",
    pwaInstall: "Add to home screen",
    pwaShowSteps: "How to install the app",
    pwaShowIos: "Show steps (iPhone)",
    pwaAlreadyInstalled: "SafeBuddy is already installed. 🎉",
    pwaInstalledOk: "SafeBuddy was installed!",
    pwaIos: "iPhone (Safari): tap 'Share' at the bottom, then 'Add to Home Screen'.",
    pwaAndroid: "Android (Chrome): open the ⋮ menu (top right) and choose 'Install app' or 'Add to home screen'.",
    versionHistory: "Version history",
    currentVersion: "Currently installed",
    version: "Version",
    whatsNewTitle: "What's new?",
    whatsNewClose: "Got it!",
    familyTitle: "Family & members",
    familyHint: "Invite family members. Linked members can view and fully manage shared SafeBuddies.",
    inviteCode: "Invite code",
    inviteEmailPlaceholder: "Member's email",
    joinCodePlaceholder: "Enter invite code",
    join: "Join",
    leaveFamily: "Leave group",
    you: "You",
    inviteSent: "Invitation sent",
    joined: "You joined the family",
    left: "You left the group",
    codeCopied: "Copied!",
    writeProtect: "Write protection",
    writeProtectHint: "Secure this buddy with a personal code. Only someone who knows the code can rewrite the NFC tag via the app.",
    writeCodePlaceholder: "Personal code",
    saveCode: "Save code",
    removeCode: "Remove protection",
    codeSaved: "Write protection updated",
    protected: "Protected",
    enterWriteCode: "Enter the personal code to rewrite this buddy.",
    verify: "Confirm",
    wrongCode: "Wrong code",
    roleEditor: "Can edit",
    roleViewer: "View only",
    owner: "Owner",
    removeMember: "Remove",
    roleUpdated: "Role updated",
    memberRemoved: "Member removed",
    inviteRoleLabel: "Role for invite",
    viewerReadOnly: "You have view-only access in this family. Editing, blocking and deleting are disabled.",
    secTitle: "How should the tag be secured?",
    secAppOnly: "App protection only",
    secAppOnlyDesc: "Can be rewritten anytime via the SafeBuddy app, protected by a personal PIN.",
    secPermanent: "Permanent write-lock",
    secPermanentDesc: "The tag is permanently locked when written (tag lock).",
    pinPrompt: "Set a personal PIN for this buddy.",
    pinPlaceholder: "Personal PIN",
    permWarnTitle: "Warning: this cannot be undone.",
    permWarn: "After this, the NFC tag can never be overwritten by anyone, not even by SafeBuddy.",
    permConfirm: "Yes, lock permanently",
    lockSuccess: "Your SafeBuddy was created and the tag is now permanently locked.",
    lockFailed: "Tag lock failed or not supported by this device (Android/Chrome only).",
    lastModifiedBy: "Last edited by",
    overview: "Overview",
    yourTags: "Your tags",
    profileStatus: "Profile status",
    profileActive: "Active",
    profileLocked: "Locked",
    avatar: "Avatar",
    chooseAvatar: "Choose motif",
    uploadImage: "Upload your own image",
    emergencyContacts: "Contacts",
    contactPhoneHint: "The number is only shown to finders if you enabled the 'Allow calls' option.",
    profileNameHint: "This name is shown to finders when your tag is scanned.",
    color_lavender: "Lavender",
    color_mint: "Mint",
    color_peach: "Peach",
    color_sky: "Sky",
    color_pink: "Pink",
    addContact: "Add contact",
    name: "Name",
    relationship: "Relationship",
    phone: "Phone",
    notes: "Important notes",
    allergies: "Allergies",
    save: "Save",
    saved: "Saved!",
    profileActiveToggle: "Profile active (publicly visible)",
    remove: "Remove",
    tagsTitle: "SafeBuddy Tags",
    activateTag: "Activate tag",
    activateHint: "Enter the code or the full SafeBuddy URL",
    codePlaceholder: "e.g. a8F3kP9 or safebuddy.at/t/a8F3kP9",
    activate: "Activate",
    viewStats: "View stats",
    statsLabel: "Stats",
    sourceDefaultTitle: "From my profile data",
    sourceDefaultDesc: "Your existing personal data will be used.",
    sourceCustomTitle: "New data",
    sourceCustomDesc: "Enter individual data specifically for this SafeBuddy.",
    showMore: "Show more",
    showLess: "Show less",
    finderPreviewNote: "This is how finders see your SafeBuddy",
    closeBtn: "Close",
    changeEmailTitle: "Change email address",
    currentEmailLabel: "Current email address",
    newEmailLabel: "New email address",
    requestEmailChange: "Send confirmation link",
    emailChangeSent: "Confirmation link sent to the new address.",
    confirmEmailTitle: "Confirm email",
    emailConfirmed: "Email address changed successfully.",
    emailConfirmError: "Confirmation failed or link expired.",
    adminBuddiesTitle: "SafeBuddy management",
    searchPlaceholder: "Search by name or code…",
    searchCodePlaceholder: "Search by code…",
    filterAll: "All",
    filterStatus: "Status",
    searchUserPlaceholder: "Search by name or email…",
    sortNewest: "Newest",
    sortOldest: "Oldest",
    changePassword: "Change password",
    currentPassword: "Current password",
    newPassword: "New password",
    repeatPassword: "Repeat new password",
    savePassword: "Save password",
    pwMismatch: "The new passwords do not match.",
    pwTooShort: "The new password must be at least 8 characters.",
    pwChanged: "Password changed successfully.",
    activationTitle: "Activation codes",
    activationRequiredLabel: "Activation code required",
    generateCodes: "Generate codes",
    codesGenerated: "Codes created",
    codeSent: "Code sent by email",
    codeUnused: "Unused",
    codeActive: "Partly redeemed",
    codeRedeemed: "Redeemed",
    codeDisabled: "Disabled",
    usesPerCodeLabel: "Activations per code (0 = unlimited)",
    redeemedWord: "redeemed",
    unlimited: "unlimited",
    printCodes: "Print",
    printInstruction: "Redeem: open SafeBuddy → 'Create SafeBuddy' → enter code.",
    printPerCode: "Activations",
    noCodes: "No codes generated yet.",
    sendCode: "Send",
    disableCode: "Disable",
    enableCode: "Enable",
    sendCodeTitle: "Send code by email",
    sendCodeDesc: "Send this activation code with instructions to:",
    activationCodeLabel: "Activation code",
    activationCodeHint: "Enter the code you received (e.g. SBXXXX-XXXX).",
    activationCodeRequired: "Please enter an activation code.",
    activationsTitle: "Activations",
    activationsAvailableWord: "available",
    redeemCodeBtn: "Redeem code",
    buyActivation: "Buy activation",
    redeemTitle: "Redeem activation code",
    redeem: "Redeem",
    codeRedeemed: "Code redeemed",
    noActivationsTitle: "No activations available",
    noActivationsText: "You need an activation to create a new buddy.",
    haveCodeBtn: "I have a code",
    activationsInfoHint: "Creating a buddy uses 1 activation.",
    footerPrivacy: "Privacy Policy",
    footerTerms: "Terms of Service",
    footerImprint: "Legal Notice",
    footerCookies: "Cookie Policy",
    footerWithdrawal: "Right of Withdrawal",
    noTags: "No tags activated yet.",
    status: "Status",
    statsTitle: "Statistics",
    events: "Events",
    noEvents: "No events recorded yet.",
    eventScan: "Scan",
    eventCall: "Call",
    eventMessage: "Message",
    back: "Back",
    colorTheme: "Color theme",
    language: "Language",
    german: "German",
    english: "English",
    helpTitle: "Help & NFC",
    nfcHowto: "How does NFC work?",
    nfcExplain: "NFC (Near Field Communication) lets you transfer data by holding your phone close to an NFC tag. SafeBuddy stores a web address on the tag – when scanned, your public finder page opens automatically.",
    nfcWriteBtn: "Write NFC tag now",
    nfcWriteHint: "Only on supported devices (Chrome on Android).",
    nfcApps: "NFC writer apps",
    nfcAppsIos: "iOS: NFC Tools on the App Store",
    nfcAppsAndroid: "Android: NFC Tools on Google Play",
    finderTitle: "Emergency information",
    finderIntro: "You found a SafeBuddy. Please help reach this person.",
    revealCall: "Reveal number & call",
    callNow: "Call now",
    leaveMessage: "Leave a message",
    yourName: "Your name (optional)",
    yourMessage: "Your message",
    sendMessage: "Send message",
    messageSent: "Thank you! Your message has been sent.",
    tagLost: "This item has been reported as LOST.",
    notAvailable: "This SafeBuddy page is currently unavailable.",
    importantInfo: "Important notes",
    poweredBy: "Powered by SafeBuddy",
    confirmLost: "Really report as lost?",
    confirmLostDesc: "Your public finder page will then show a lost notice.",
    cancel: "Cancel",
    confirm: "Yes, report as lost",
    selectTag: "Select tag",
    createBuddy: "Create SafeBuddy",
    buddyName: "Name (optional)",
    buddyNamePlaceholder: "e.g. Keychain, School backpack, Dog collar, Bike, Stroller, Suitcase",
    create: "Create",
    creating: "Creating…",
    generatedUrl: "Your SafeBuddy URL",
    copyUrl: "Copy URL",
    urlCopied: "URL copied!",
    rename: "Rename",
    deleteBuddy: "Delete",
    deleteConfirm: "Delete SafeBuddy?",
    deleteConfirmDesc: "This SafeBuddy and all its statistics will be permanently deleted.",
    manageBuddies: "My SafeBuddies",
    shareLocation: "Share my location",
    locationAttached: "Location attached ✓",
    locationError: "Could not get your location",
    viewLocation: "View location",
    buddyCreated: "SafeBuddy created!",
    unnamed: "Unnamed",
    done: "Done",
    editBuddy: "Edit",
    buddyProfile: "SafeBuddy profile",
    dataSource: "Which data to show?",
    standardData: "My profile data",
    ownData: "Custom data",
    displayName: "Display name",
    contactOptions: "Contact options",
    allowCalls: "Allow calls",
    allowMessages: "Allow messages",
    editData: "Edit data",
    buddyUpdated: "SafeBuddy updated",
    emailNotifications: "Email notifications",
    notifyScan: "Email when my tag is scanned",
    notifyMessage: "Email on new message",
    buddyAvatar: "Avatar / profile picture",
    nfcGuide: "Picture guide: writing an NFC tag",
    downloadPdf: "Download guide as PDF",
    shareGuide: "Share guide",
    share: "Share",
    shareGuideText: "How to write your SafeBuddy NFC tag – here's the guide:",
    linkCopied: "Link copied!",
    preview: "Preview",
    previewBanner: "Preview mode – scans are not counted.",
    feedbackTitle: "Feedback",
    feedbackHint: "Tell us what you like or what we can improve.",
    feedbackPlaceholder: "Your message to us …",
    anonymous: "Send anonymously",
    sendFeedback: "Send feedback",
    feedbackSent: "Thanks for your feedback! 💜",
    legalTitle: "Legal & Privacy",
    imprint: "Imprint",
    imprintText: "Owner of the web app:\nWalch Mathias\nMW3D\nNeufeldstraße 13\nA-6890 Lustenau, Austria\nContact: office@mw3d.at",
    privacy: "Privacy Policy",
    privacyText: "Controller: Walch Mathias (MW3D), Neufeldstraße 13, A-6890 Lustenau, office@mw3d.at.\n\nWhat data? Account (email), profile (name, avatar, emergency contacts, notes, allergies), SafeBuddy tags and statistics events (scans, calls, messages with timestamps). Shared emergency data is accessible via the public finder URL – you decide what is visible and whether a tag is active.\n\nPurpose & legal basis: Providing the service (contract) and email notifications if enabled by you.\n\nRetention: Data is stored until you delete it or remove your account/tag.\n\nYour rights: access, rectification, erasure and objection – requests to office@mw3d.at.\n\nThird parties: Processors are used for email delivery and image storage; data is processed solely to provide the service.",
    policies: "Other Policies",
    policiesText: "Terms (short): SafeBuddy connects finders of lost items to you via NFC/QR. Misuse (e.g. storing others'/false data or harassing messages) is prohibited.\n\nLiability: There is no guarantee that a finder will get in touch. In emergencies always use official emergency numbers.\n\nLocation: Finders may optionally and voluntarily share their location.\n\nContact: office@mw3d.at",
    eventsScansTitle: "All scans",
    eventsCallsTitle: "All calls",
    eventsMessagesTitle: "All messages",
    noEventsYet: "No entries yet.",
    skip: "Skip",
    next: "Next",
    getStarted: "Let's go!",
    inboxTitle: "Message inbox",
    noMessagesInbox: "No messages yet.",
    restartOnboarding: "Replay intro",
    featuresTitle: "Feature overview",
    featPreview: "Preview: On 'Safe Buddies' tap the eye icon on a tag – see your public finder page without counting scans.",
    featProfile: "My Profile: enter emergency data once – it applies to all tags automatically.",
    featStats: "Statistics: on Home tap the Scans/Calls/Messages tiles for full details.",
    featLost: "Report lost: mark a tag as lost – finders then see a clear notice.",
    onbTitle1: "Welcome to SafeBuddy! 🐾",
    onbText1: "SafeBuddy connects lost items to your emergency contacts via NFC tags – no app download needed.",
    onbTitle2: "Fill in My Profile first ⭐",
    onbText2: "Enter your personal emergency data ONCE under 'My Profile' (name, contacts, notes, allergies). It then becomes available automatically for ALL your SafeBuddy tags.",
    onbTitle3: "Create & share tags 🎉",
    onbText3: "Create SafeBuddy tags, write your NFC tag with the URL, and see in the statistics when someone scanned your tag or contacted you.",
    showHelpQuestion: "Show NFC guide?",
    showHelpHint: "After creating, shows you how to write the NFC tag.",
    callHint: "When enabled, your phone number can be revealed and called.",
    buddyActive: "SafeBuddy active",
    deactivatedNotice: "This SafeBuddy has been deactivated.",
    editMyProfile: "Edit my profile data",
    openGuide: "Open illustrated guide",
    guideTitle: "Illustrated guide",
    guideIntro: "From sign-up to a finished SafeBuddy tag in 5 easy steps.",
    guideStepLabel: "Step",
    guideBackToSettings: "Back to settings",
    guideS1Title: "Fill in your profile",
    guideS1Text: "Open 'My Profile' and enter your emergency data ONCE: name, emergency contacts, important notes and allergies. It then applies automatically to all your SafeBuddies.",
    guideS1Marker: "Tap 'Add contact' and save.",
    guideS2Title: "Create a SafeBuddy",
    guideS2Text: "Go to 'Safe Buddies' and tap the big plus button at the bottom right. Enter a name (e.g. school backpack) and tap 'Create'.",
    guideS2Marker: "The plus opens the create dialog.",
    guideS3Title: "Copy your URL",
    guideS3Text: "After creating you get a personal SafeBuddy URL. Tap 'Copy URL' – the address is now on your clipboard.",
    guideS3Marker: "This URL goes onto the NFC tag next.",
    guideS4Title: "Write the NFC tag",
    guideS4Text: "In SafeBuddy use the 'Write NFC tag now' button (Android/Chrome) OR an NFC app like 'NFC Tools'. Hold your phone to the tag and save the copied URL as a web address (URL/link).",
    guideS4Marker: "Hold phone to tag – wait a moment – done.",
    guideS5Title: "Done – what the finder sees",
    guideS5Text: "When someone scans the tag with a phone, your finder page opens automatically with your emergency info. You are notified by email instantly.",
    guideS5Marker: "Call or leave a message – no app needed.",
    nfcWriteTitle: "Write NFC tag",
    nfcWriteAndroidHint: "Only works on Android with Chrome.",
    nfcWriteSelectTag: "Choose one of your active SafeBuddy tags:",
    nfcWriteNoActiveTags: "You don't have any active tags yet. Create or activate a SafeBuddy first.",
    nfcWriteHoldTag: "Now hold your phone to the NFC tag …",
    nfcWriteSuccess: "NFC tag written successfully!",
    nfcWriteFailed: "Writing to NFC failed. Please try again.",
    nfcWriteAgain: "Write another tag",
    nfcWriteUnsupportedText: "Your device or browser does not support direct NFC writing (e.g. iPhone or desktop). Use a free NFC app instead: copy your tag's URL and write it to the tag with that app.",
    nfcWriteCopyLabel: "URL to paste into the NFC app:",
    messageEmailHint: "Tip: In Settings you can enable an email notification whenever someone leaves you a message.",
    onbViewGuide: "View the illustrated guide",
    admin: "Admin",
    adminTitle: "Admin area",
    adminSubtitle: "Overview & statistics",
    adminTotalUsers: "Registered users",
    adminTotalTags: "Created tags",
    adminActiveTags: "Active tags",
    adminBlockedTags: "Blocked tags",
    adminLostTags: "Lost tags",
    adminRecentUsers: "Latest registrations",
    adminNoUsers: "No users yet.",
    // shop
    shop: "Shop",
    shopTitle: "SafeBuddy Shop",
    shopSubtitle: "Buy activation codes easily",
    activityTitle: "Activity",
    activitySubtitle: "All scans, calls & messages",
    eventsMarkAllRead: "Mark all read",
    eventsDeleteAll: "Delete all",
    markRead: "Mark read",
    markUnread: "Mark unread",
    eventsDeleteConfirmTitle: "Delete entries?",
    eventsDeleteConfirmDesc: "Do you really want to delete the selected entries? You can undo for 5 seconds.",
    eventsSearchPlaceholder: "Search by date, buddy or content",
    sortDateDesc: "Newest first",
    sortDateAsc: "Oldest first",
    sortByBuddy: "By buddy",
    sortByType: "By type",
    selectMultiple: "Select multiple",
    deleteSelected: "Delete",
    eventsDeleted: "Deleted",
    deleteFailed: "Delete failed",
    undo: "Undo",
    edit: "Edit",
    delete: "Delete",
    ticketUpdated: "Ticket updated",
    ticketDeleted: "Ticket deleted",
    ticketBeingHandled: "Ticket is already being handled",
    outOfStock: "Not available",
    deleteTicketTitle: "Delete ticket?",
    deleteTicketDesc: "Do you really want to delete this ticket? You can undo for 5 seconds.",
    ordersTitle: "Order history",
    ordersSubtitle: "Your orders & purchased codes",
    ordersEmpty: "You haven't placed any orders yet.",
    ordersCardTitle: "Order history",
    ordersCardSubtitle: "View orders & retrieve codes",
    orderStatusPaid: "Paid",
    orderStatusPending: "Pending",
    orderStatusFailed: "Failed",
    orderDiscount: "Discount",
    orderShipping: "Shipping",
    orderFree: "Free",
    orderTotal: "Total",
    orderCodes: "Your activation codes",
    orderCodesHint: "Redeem the codes under Settings → \"Redeem activation code\".",
    orderCopy: "Copy",
    orderCodeCopied: "Code copied",
    shopAdminTitle: "Shop management",
    shopEnabledLabel: "Enable shop for all users",
    shopEnabledHint: "While this is off, only admins can see the shop.",
    shopPreview: "Open shop preview",
    paypalConfigured: "PayPal is connected",
    paypalNotConfigured: "PayPal credentials are missing – purchases become possible once the keys are set.",
    shopProductsTitle: "Products",
    shopOrdersTitle: "Orders",
    newProduct: "New product",
    editProductTitle: "Edit product",
    productName: "Name",
    productDesc: "Description",
    productPrice: "Price (€)",
    productCodesCount: "Included activation codes",
    productVisible: "Visible in shop",
    productImage: "Product image",
    uploadImage: "Upload image",
    saveProduct: "Save product",
    deleteProductConfirm: "Really delete this product?",
    noProducts: "No products created yet.",
    noOrders: "No orders yet.",
    hidden: "Hidden",
    visibleBadge: "Visible",
    codesIncluded: "codes",
    buyNow: "Buy",
    shopClosed: "The shop is currently unavailable.",
    shopEmpty: "No products available right now.",
    checkoutTitle: "Complete purchase",
    paymentComingSoon: "Payment will be available soon. Please check back later.",
    taxNote: "Pursuant to § 6 (1) no. 27 of the Austrian VAT Act, no VAT is charged. All prices are gross prices.",
    mustAcceptTerms: "Please accept the Terms of Service and the Privacy Policy.",
    discountCodeLabel: "Discount code",
    applyLabel: "Apply",
    discountApplied: "Discount applied",
    discountLabel: "Discount",
    fromPhonebook: "Choose from phone book",
    simpleModeLabel: "Simple mode",
    simpleModeHint: "Reduces the app to the essentials: create a SafeBuddy only.",
    createNewBuddy: "Create new SafeBuddy",
    toFullView: "To full view",
    simpleOn: "On",
    simpleOff: "Off",
    guestTryFree: "Try without signing up",
    guestModeTitle: "Test mode",
    guestModeDesc: "Your data will be deleted automatically. Register now to keep everything.",
    guestDaysPrefix: "in",
    guestRegisterNow: "Register now",
    guestEmailLabel: "Email for reminder (optional)",
    guestEmailSave: "Save",
    guestEmailSaved: "Email saved",
    guestConvertTitle: "Create account & keep data",
    guestConvertDesc: "Your test data (SafeBuddys, profile, history) will be transferred automatically.",
    guestConvertSuccess: "Welcome! Your data has been transferred.",
    convertCreate: "Create account",
    designStyle: "Design",
    groups: "Groups",
    designClassic: "Classic",
    designModern: "Modern",
    hourWord: "hour",
    hoursWord: "hours",
    color_petrol: "Petrol",
    color_navy: "Navy",
    color_graphit: "Graphite",
    color_forest: "Forest",
    color_bordeaux: "Bordeaux",
    dayWord: "day",
    daysWord: "days",
    guestNoEmail: "No email",
    guestStatusActive: "Active",
    guestStatusExpired: "Expired",
    guestStatusConverted: "Converted",
    adminGuestsTitle: "Guest accounts",
    adminGuestsSubtitle: "Temporary test accounts with expiry date",
    adminGuestsEmpty: "No guest accounts yet",
    adminGuestsBuddies: "SafeBuddys",
    adminGuestExpires: "Expires",
    adminGuestConverted: "Converted",
    pinPrefilledHint: "PIN was applied automatically – you can confirm or change it.",
    purchaseSuccessTitle: "Purchase successful! 🎉",
    purchaseSuccessDesc: "Your activation codes were sent by email:",
    orderPending: "Pending",
    orderPaid: "Paid",
    orderFailed: "Failed",
    buyer: "Buyer",
    close: "Close",
    edit: "Edit",
    delete: "Delete",
    addToCartLabel: "Add to cart",
    cartTitle: "Cart",
    emptyCart: "Your cart is empty.",
    continueShopping: "Continue shopping",
    chooseColor: "Choose color",
    chooseMotif: "Choose motif",
    quantityLabel: "Quantity",
    unitPriceLabel: "Unit price",
    lineTotalLabel: "Total",
    addLabel: "Add",
    subtotalLabel: "Subtotal",
    shippingLabel: "Shipping",
    shippingCostLabel: "Shipping cost",
    totalLabel: "Total",
    freeLabel: "Free",
    deliveryTimeLabel: "Delivery time",
    chooseShipping: "Choose shipping option",
    customerNameLabel: "Name",
    customerEmailLabel: "Email",
    deliveryAddressLabel: "Delivery address",
    checkoutSummary: "Order summary",
    fillRequired: "Please fill in all required fields.",
    chooseShippingFirst: "Please choose a shipping option.",
    itemColorLabel: "Color",
    itemMotifLabel: "Motif",
    removeLabel: "Remove",
    proceedCheckout: "Proceed to checkout",
    priceFrom: "from",
    cartAdded: "Added to cart",
    colorsLabel: "Color variants",
    motifsLabel: "Motif variants",
    addColor: "Add color",
    addMotif: "Add motif",
    variantName: "Name",
    variantDesc: "Description",
    variantHex: "Color (hex)",
    variantSurcharge: "Surcharge (€)",
    variantImage: "Image",
    minQtyLabel: "Min. quantity",
    maxQtyLabel: "Max. quantity",
    shippingAdminTitle: "Shipping",
    newShipping: "New shipping option",
    editShippingTitle: "Edit shipping option",
    shippingName: "Name",
    shippingDesc: "Description",
    shippingPrice: "Price (€)",
    shippingDeliveryTime: "Delivery time (e.g. 1-3 business days)",
    shippingFreeAbove: "Free shipping above (€, optional)",
    shippingActive: "Active",
    noShipping: "No shipping options yet.",
    saveShipping: "Save",
    deleteShippingConfirm: "Really delete this shipping option?",
    streetLabel: "Street",
    houseNumberLabel: "House number",
    postalCodeLabel: "Postal code",
    cityLabel: "City",
    countryLabel: "Country",
    selectCountry: "Select country",
    shippingBasePrice: "Base price (fallback)",
    countryRates: "Country shipping rates",
    countryRatesHint: "Leave empty = base price is used.",
    forgotPassword: "Forgot password?",
    resetEmailPrompt: "Enter your email address and we'll send you a reset link.",
    sendResetLink: "Send reset link",
    backToLogin: "Back to sign in",
    resetSent: "If an account exists, we've emailed you a reset link.",
    resetTitle: "Set a new password",
    newPassword: "New password",
    confirmPassword: "Confirm password",
    resetSubmit: "Save password",
    resetSuccess: "Password changed! You can now sign in.",
    resetInvalid: "The link is invalid or has expired.",
    passwordsMismatch: "Passwords do not match.",
    passwordTooShort: "Password must be at least 6 characters.",
    pwStrength: "Password strength",
    pwWeak: "Weak",
    pwMedium: "Medium",
    pwGood: "Good",
    pwStrong: "Strong",
  },
};
